import { axiosServices } from "./axiosServices";

export const statusmappingServices = {
  getstatusManagements,
  deletestatusManagement,
  createNewstatus,
  createPrioritiesSetup,
  deletesetupPriorities,
  createTatSetup,
  deletesetupTat,
};

function getstatusManagements(param) {
  return axiosServices.getAxios(`/v1/admin/status-management`).then((res) => {
    // console.log(res);
    return res;
  });
}

function deletestatusManagement(id, param) {
  return axiosServices
    .deleteAxios(`/v1/admin/status-management/statuses/${id}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function createNewstatus(param) {
  let data = { statusName: param };
  return axiosServices
    .postAxios(`/v1/admin/status-management/statuses`, data)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function createPrioritiesSetup(param) {
  return axiosServices
    .postAxios(`/v1/admin/status-management/priorities`, param)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function deletesetupPriorities(id, param) {
  return axiosServices
    .deleteAxios(`/v1/admin/status-management/priorities/${id}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function createTatSetup(data, id) {
  return axiosServices
    .postAxios(`/v1/admin/status-management/priorities/${id}/tats`, data)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function deletesetupTat(id1, id2) {
  return axiosServices
    .deleteAxios(`/v1/admin/status-management/priorities/${id1}/tats/${id2}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
